import React from "react";
import { STRATEGY, STRATEGY_LABELS } from "../../Utils/djAlgos";
import { Panel, SectionLabel } from "../../Components/Hardware";

const dotForScore = (s) => {
  if (s == null) return "·";
  if (s >= 0.85) return "✓";
  if (s >= 0.6) return "~";
  return "✗";
};

const KNOB_SLOT_WIDTH = 220;

export default function NextUpPanel({ nextTrack, nextBpm, nextCamelot, nextEnergy, breakdown, autoStrategy, override, setOverride, queueMode, queueLength, playedCount, centerSlot }) {
  const autoLabel = autoStrategy ? STRATEGY_LABELS[autoStrategy] : "—";
  return (
    <div className="relative bg-gradient-to-b from-black via-neutral-950 to-neutral-950 px-3 pt-3 pb-2">
      {centerSlot && (
        <div
          className="absolute left-1/2 top-0 z-30"
          style={{ transform: "translate(-50%, -220px)" }}
        >
          {centerSlot}
        </div>
      )}

      <div className="grid grid-cols-[1fr_auto_1fr] gap-3 items-stretch">
        <div className="flex flex-wrap items-stretch gap-3 justify-end min-w-0">
          <Panel className="flex-1 min-w-[240px] flex items-center gap-3">
            <SectionLabel>Next</SectionLabel>
            {nextTrack ? (
              <>
                {nextTrack.albumArtUrl && (
                  <img
                    src={nextTrack.albumArtUrl}
                    alt=""
                    className="w-10 h-10 rounded object-cover shrink-0 border border-neutral-800"
                  />
                )}
                <div className="min-w-0 flex-1">
                  <div className="text-sm text-white truncate font-medium">{nextTrack.title}</div>
                  <div className="text-xs text-neutral-400 truncate">{nextTrack.artist}</div>
                </div>
              </>
            ) : (
              <div className="text-sm text-neutral-500 italic">— no track queued —</div>
            )}
          </Panel>

          <Panel className="flex flex-col justify-center items-center min-w-[96px]">
            <SectionLabel>BPM</SectionLabel>
            <div
              className="font-mono text-2xl leading-none tabular-nums text-purple-300 mt-0.5"
              style={{ textShadow: "0 0 10px rgba(192, 132, 252, 0.5)" }}
            >
              {nextBpm != null ? nextBpm.toFixed(1) : "---"}
            </div>
          </Panel>

          <Panel className="flex flex-col justify-center items-center min-w-[80px]">
            <SectionLabel>Key</SectionLabel>
            <div className="font-mono text-lg leading-none tabular-nums text-emerald-300 mt-1">
              {nextCamelot || "---"}
            </div>
          </Panel>

          <Panel className="flex flex-col justify-center items-center min-w-[80px]">
            <SectionLabel>Energy</SectionLabel>
            <div className="font-mono text-lg leading-none tabular-nums text-amber-300 mt-1">
              {nextEnergy != null ? nextEnergy.toFixed(2) : "---"}
            </div>
          </Panel>
        </div>

        <div style={{ width: KNOB_SLOT_WIDTH }} aria-hidden />

        <div className="flex flex-wrap items-stretch gap-3 justify-start min-w-0">
          {breakdown && (
            <Panel className="flex flex-col justify-center min-w-[170px]">
              <SectionLabel>Match</SectionLabel>
              <div className="font-mono text-[11px] leading-tight text-neutral-300 mt-1 space-y-0.5">
                <div>BPM <span className="text-purple-300">{dotForScore(breakdown.bpmS)}</span> {(breakdown.bpmS * 100).toFixed(0)}</div>
                <div>Key <span className="text-emerald-300">{dotForScore(breakdown.keyS)}</span> {(breakdown.keyS * 100).toFixed(0)}</div>
                <div>Engy <span className="text-amber-300">{dotForScore(breakdown.energyS)}</span> {(breakdown.energyS * 100).toFixed(0)}</div>
              </div>
            </Panel>
          )}

          <Panel className="flex flex-col justify-center min-w-[210px]">
            <SectionLabel>Strategy</SectionLabel>
            <select
              value={override}
              onChange={(e) => setOverride(e.target.value)}
              className="bg-black text-white text-xs rounded px-2 py-1 mt-1 outline-none focus:ring-1 focus:ring-purple-500 border border-neutral-800 font-mono"
            >
              <option value="auto">AUTO{autoStrategy ? ` · ${autoLabel.toUpperCase()}` : ""}</option>
              <option value={STRATEGY.MATCHED_16}>{STRATEGY_LABELS[STRATEGY.MATCHED_16].toUpperCase()}</option>
              <option value={STRATEGY.SHORT_4}>{STRATEGY_LABELS[STRATEGY.SHORT_4].toUpperCase()}</option>
              <option value={STRATEGY.CUT}>{STRATEGY_LABELS[STRATEGY.CUT].toUpperCase()}</option>
            </select>
          </Panel>

          {queueMode && queueLength > 0 && (
            <Panel className="flex flex-col justify-center items-center min-w-[96px]">
              <div className="flex items-center gap-1.5">
                <span
                  className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"
                  style={{ boxShadow: "0 0 6px #34d399" }}
                />
                <SectionLabel>Queue</SectionLabel>
              </div>
              <div className="font-mono text-lg leading-none tabular-nums text-emerald-300 mt-1">
                {playedCount}/{queueLength}
              </div>
            </Panel>
          )}
        </div>
      </div>
    </div>
  );
}
